import { useExtension } from '~/hooks/useExtension';
import { useFirefoxExtension } from '~/hooks/useFirefoxExtension';

import { DoctorCard } from './DoctorCard';

const title = 'Extension Info';
const notApplicable = 'N/A';
enum Label {
  Installed = 'Installed',
  Name = 'Name',
  Version = 'Version',
}

const StandardExtensionInfo = () => {
  const { isInstalled, name, version, loading } = useExtension();

  if (loading) {
    return null;
  }

  return (
    <DoctorCard
      title={title}
      rows={[
        {
          label: Label.Installed,
          value: isInstalled,
        },
        {
          label: Label.Name,
          value: name ?? notApplicable,
        },
        {
          label: Label.Version,
          value: version ?? notApplicable,
        },
      ]}
    />
  );
};

const FirefoxFallbackExtensionInfo = () => {
  const { isInstalledInFirefox, name, version, loading } = useFirefoxExtension();

  if (loading) {
    return null;
  }

  return (
    <DoctorCard
      title={title}
      rows={[
        {
          label: Label.Installed,
          value: isInstalledInFirefox,
        },
        {
          label: Label.Name,
          value: name ?? notApplicable,
        },
        {
          label: Label.Version,
          value: version ?? notApplicable,
        },
      ]}
    />
  );
};

export const ExtensionInfo = () => {
  const { shouldFallBack } = useExtension();
  return shouldFallBack ? <FirefoxFallbackExtensionInfo /> : <StandardExtensionInfo />;
};
